export default __webpack_public_path__ + "static/media/N_wdt_c_cap_1.3ad8fbf4.mp3";